export default __webpack_public_path__ + "static/media/backArrow.913d0b73.svg";